import Vue from 'vue';

Vue.filter('asReplaceShortcode', function (text, shortcode, replacement) {
	// console.log(text,  shortcode, replacement);
	if (!text || !shortcode || !replacement) return text;
	const regex = new RegExp(`\\[${shortcode}\\]`, 'g');
	return text.replace(regex, replacement);
});